import type { FC } from 'react';

import PageFrame from 'src/components/common/PageFrame';
import PasswordResetConfirmContent from 'src/components/account/PasswordResetConfirmPage/components/PasswortResetConfirmContent';

const ResetConfirmPageMobile: FC = () => (
  <PageFrame>
    <PasswordResetConfirmContent />
  </PageFrame>
);

export default ResetConfirmPageMobile;
